import React, { useContext } from "react";
import "./projectList.css";

import { projects } from "../../projectdata";

import Footer from "../Footer";
import { GitHub, Launch } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ThemeContext } from "../../context";
import Projectslider from "../Projectslider";
import StarCanvas from "../Pages/StarCanvas";
import LightModeBubbles from "../Pages/LightModeBubbles";

const ProjectList = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div>
      {darkMode ? <StarCanvas /> : <LightModeBubbles />}
      <div className="my-component">
        <Box
          className="proj-main"
          paddingTop={{ xs: "80px", lg: "100px", xl: "103px" }}
        >
          <span
            className="pl-title"
            style={{
              borderRight: darkMode ? "1px solid #a79149" : "2px solid #a5a5a5",
              borderBottom: darkMode
                ? "1px solid #a79149"
                : "2px solid #a5a5a5",
              boxShadow: darkMode
                ? "5px 6px 10px #a79149"
                : "8px 8px 10px rgba(0, 0, 0, 0.2)",
              cursor: "default",
            }}
          >
            Projects
          </span>
          <div className="proj-m">
            <Box
              width="100%"
              display="flex"
              flexDirection={{ xs: "column", lg: "row" }}
              justifyContent={{ xs: "none", lg: "space-between" }}
              gap="2rem"
            >
              {projects.map((project, index) => (
                <Box
                  key={index}
                  width={{ xs: "100%", lg: "80%" }}
                  textAlign="center"
                  display="flex"
                  flexDirection="column"
                  margin={{ xs: "none", md: "auto" }}
                  sx={{
                    cursor: "default",
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "auto", lg: "380px" },
                      marginRight: "auto",
                      marginLeft: "auto",
                      border: darkMode
                        ? "2px solid #a79149"
                        : "2px solid #a5a5a5",
                      boxShadow: darkMode
                        ? "0 0 20px #d4af37"
                        : "0 0 20px #a5a5a5",
                      cursor: "default",
                    }}
                    className="p"
                  >
                    <div
                      style={{
                        height: "30px",
                        backgroundColor: "rgba(0,0,0,0.7)",
                        position: "sticky",
                        zIndex: 2,
                        display: "flex",
                        alignItems: "center",
                        padding: "0 10px",
                        gap: "8px",
                        borderTopLeftRadius: "16px",
                        borderTopRightRadius: "16px",
                      }}
                    >
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          background: "#ff605c", // red
                        }}
                      />
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          background: "#ffbd44", // yellow
                        }}
                      />
                      <span
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          background: "#00ca4e", // green
                        }}
                      />
                    </div>
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noreferrer"
                      width="100%"
                    >
                      <img
                        src={project.image}
                        alt=""
                        className="proj-img"
                        width="100%"
                      />
                    </a>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    marginTop="20px"
                    sx={{
                      cursor: "default",
                    }}
                  >
                    <div className="proj-t">{project.title}</div>
                    <div className="img-link">
                      <a href={project.github} target="_blank" rel="noreferrer">
                        <GitHub
                          sx={{
                            size: 24,
                            color: darkMode ? "#fff" : "#000",
                          }}
                        />
                      </a>
                      <a href={project.link} target="_blank" rel="noreferrer">
                        <Launch
                          sx={{
                            size: 24,
                            marginLeft: "8px",
                            color: darkMode ? "#fff" : "#000",
                          }}
                        />
                      </a>
                    </div>
                  </Box>

                  <Box
                    width={{ xs: "100%", lg: "100%" }}
                    textAlign="center"
                    marginTop="15px"
                    sx={{
                      cursor: "default",
                    }}
                  >
                    {/* <div className="flex overflow-auto space-x-3 pb-2 text-desc"> */}
                    {project.tools.map((disc, index) => (
                      <span
                        style={{
                          border: darkMode
                            ? "2px solid #a79149"
                            : "2px solid #a5a5a5",
                          boxShadow: darkMode
                            ? "0 0 10px #d4af37"
                            : "0 0 10px #a5a5a5",
                        }}
                        className="proj-border"
                        key={index}
                      >
                        {disc}
                      </span>
                    ))}
                    {/* </div> */}
                  </Box>

                  <div className="proj-desc">{project.description}</div>
                </Box>
              ))}
            </Box>
          </div>

          <Projectslider />

          <Footer />
        </Box>
      </div>
    </div>
  );
};

export default ProjectList;
